export const CMD = 'DoEducationSupport';
export const OBJTYPE = 'EducationTestMsg';

export const openState = 3;
export const closedState = 7;
